import { useEffect, useCallback, useRef } from 'react'
import useIsMounted from '../../../../../../../../hooks/useIsMounted'

const useHandleStickyButton = params => {
  const {
    isDesktop,
    setIsStickyButton,
    buttonSectionId,
    isStickyButton
  } = params
  const isMounted = useIsMounted()
  const isScrolling = useRef(0)

  const getScrollTop = useCallback(
    id => {
      const elem = document.getElementById(id)
      let position = {}
      if (elem) {
        position = elem.getBoundingClientRect()
      }

      return position.top
    },
    [],
  )

  const handleScroll = useCallback(
    () => {
      window.clearTimeout(isScrolling.current)

      isScrolling.current = setTimeout(() => {
        const stickyCartPos = getScrollTop(buttonSectionId)
        if (stickyCartPos < 650) {
          setIsStickyButton(false)
        } else {
          setIsStickyButton(true)
        }
      }, 50)
    },
    [setIsStickyButton, getScrollTop, buttonSectionId],
  )

  useEffect(() => {
    if (typeof window === "undefined") return;

    const event = new CustomEvent("cart_proceed_to_checkout_sticky_section", {
      detail: { isVisible: isStickyButton },
    });
    window.dispatchEvent(event);
  }, [isStickyButton])

  useEffect(
    () => {
      if (!isDesktop) {
        if (__BROWSER__ && isMounted()) {
          window.addEventListener('scroll', handleScroll, true)
          window.addEventListener('touchmove', handleScroll, true)
          window.addEventListener('wheel', handleScroll, true)
        }
        return () => {
          window.removeEventListener('scroll', handleScroll, true)
          window.removeEventListener('touchmove', handleScroll, true)
          window.removeEventListener('wheel', handleScroll, true)
        }
      }

      return () => {}
    },
    [handleScroll, isMounted, isDesktop],
  )
}

export default useHandleStickyButton
